import React, { useState, useEffect } from 'react';
import { ETAPAS, fechaHora, ultimoContacto } from '../../../utils/settingFormato';

// Leads del setting (spec §5.2): en el computador, una columna por etapa de trabajo y las cerradas plegadas; en el
// teléfono, una lista con filtro por etapa. Búsqueda por usuario. Los leads llegan ordenados desde el backend.
const TRABAJO = ETAPAS.filter((e) => e.trabajo);
const CERRADAS = ETAPAS.filter((e) => !e.trabajo);
const TELEFONO = '(max-width: 720px)';

export const useTelefono = () => {
  const consultar = () => (typeof window.matchMedia === 'function' ? window.matchMedia(TELEFONO).matches : false);
  const [es, setEs] = useState(consultar);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const mq = window.matchMedia(TELEFONO);
    const cambio = () => setEs(mq.matches);
    if (mq.addEventListener) mq.addEventListener('change', cambio);
    return () => { if (mq.removeEventListener) mq.removeEventListener('change', cambio); };
  }, []);
  return es;
};

// La fecha va entera en una línea: en columnas de ~230 px se partía en el guion ("23-" / "10 08:55").
const Fecha = ({ iso }) => <span className="au-set-fecha">{fechaHora(iso)}</span>;

const Tarjeta = ({ lead, pendiente, onAbrir }) => {
  const contacto = ultimoContacto(lead);
  return (
    <button type="button" className="au-set-tarjeta" onClick={(e) => onAbrir(lead.conv_id, e.currentTarget)}>
      <span className="au-set-tarjeta-usuario">{`@${lead.usuario}${lead.caliente ? ' 🔥' : ''}`}</span>
      {lead.origen && <span className="muted mono">{lead.origen}</span>}
      <span className="mono">
        {`Paso ${lead.paso}`}
        {contacto && <>{' · último contacto '}<Fecha iso={contacto} /></>}
      </span>
      {lead.vence_24h && <span className="mono hot">{'Ventana vence '}<Fecha iso={lead.vence_24h} /></span>}
      {!lead.vence_24h && lead.proximo && <span className="mono">{'Próximo seguimiento '}<Fecha iso={lead.proximo} /></span>}
      {lead.dueno === 'agustin' && <span className="au-set-badge">Lo lleva Agustín</span>}
      {pendiente && <span className="au-set-badge pendiente">pendiente</span>}
    </button>
  );
};

const LeadsSetting = ({ leads, pendientes, onAbrir }) => {
  const telefono = useTelefono();
  const [busca, setBusca] = useState('');
  const [filtro, setFiltro] = useState('todas');
  const [abiertas, setAbiertas] = useState(() => new Set());

  const q = busca.trim().replace(/^@/, '').toLowerCase();
  const visibles = leads.filter((l) => !q || l.usuario.toLowerCase().includes(q));
  const de = (etapa) => visibles.filter((l) => l.etapa === etapa);
  const tarjeta = (l) => (
    <Tarjeta key={l.conv_id} lead={l} pendiente={Boolean((pendientes[l.conv_id] || []).length)} onAbrir={onAbrir} />
  );
  const alternar = (clave) => setAbiertas((prev) => {
    const s = new Set(prev);
    if (s.has(clave)) s.delete(clave); else s.add(clave);
    return s;
  });

  return (
    <div className="au-set-leads">
      <input
        className="au-admin-search-input au-set-buscar"
        placeholder="Buscar @usuario"
        aria-label="Buscar por usuario"
        value={busca}
        onChange={(e) => setBusca(e.target.value)}
      />
      {telefono ? (
        <div className="au-set-lista">
          <select aria-label="Filtrar por etapa" value={filtro} onChange={(e) => setFiltro(e.target.value)}>
            <option value="todas">{`Todas las etapas (${visibles.length})`}</option>
            {ETAPAS.map((e) => <option key={e.clave} value={e.clave}>{`${e.etiqueta} (${de(e.clave).length})`}</option>)}
          </select>
          {(filtro === 'todas' ? visibles : de(filtro)).map(tarjeta)}
        </div>
      ) : (
        <>
          <div className="au-set-columnas">
            {TRABAJO.map((e) => (
              <section key={e.clave} className="au-set-columna" aria-label={e.etiqueta}>
                <h3 className="au-set-columna-titulo">
                  {e.etiqueta} <span className="mono muted">{de(e.clave).length}</span>
                </h3>
                {de(e.clave).map(tarjeta)}
              </section>
            ))}
          </div>
          <div className="au-set-cerradas">
            {CERRADAS.map((e) => (
              <div key={e.clave} className="au-set-plegada">
                <button
                  type="button"
                  className="au-set-plegada-titulo"
                  aria-expanded={abiertas.has(e.clave)}
                  onClick={() => alternar(e.clave)}
                >
                  {`${e.etiqueta} (${de(e.clave).length})`}
                </button>
                {abiertas.has(e.clave) && de(e.clave).map(tarjeta)}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LeadsSetting;
